/**
 * MUSKLE Bee Hive — platform page light/dark theme (info, templates, etc.)
 */
(function (global) {
  'use strict';

  var STORAGE_KEY = 'muskleBeeHivePlatformTheme';

  function applyTheme(root, mode, labels) {
    if (mode !== 'light' && mode !== 'dark') mode = 'light';
    root.setAttribute('data-bh-platform-theme', mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* ignore */
    }
    var themeBtn = root.querySelector('[data-bh-platform-theme-toggle]');
    var themeLabel = root.querySelector('[data-bh-platform-theme-label]');
    if (themeBtn) themeBtn.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
    if (themeLabel && labels) {
      themeLabel.textContent = mode === 'light' ? labels.light : labels.dark;
    }
  }

  function readStoredTheme() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw === 'light' || raw === 'dark' ? raw : 'light';
    } catch (e) {
      return 'light';
    }
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-bh-platform-theme-ready') === '1') return;
    var themeBtn = root.querySelector('[data-bh-platform-theme-toggle]');
    var labels = {
      light: root.getAttribute('data-bh-platform-theme-label-light') || 'DONKER',
      dark: root.getAttribute('data-bh-platform-theme-label-dark') || 'LICHT',
    };
    applyTheme(root, readStoredTheme(), labels);
    if (themeBtn) {
      themeBtn.addEventListener('click', function () {
        var current = root.getAttribute('data-bh-platform-theme') === 'light' ? 'dark' : 'light';
        applyTheme(root, current, labels);
      });
    }
    root.setAttribute('data-bh-platform-theme-ready', '1');
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bh-platform-page]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  global.MuskleBeeHivePlatformTheme = { initRoot: initRoot, readStoredTheme: readStoredTheme };
})(window);
